module.exports = __webpack_public_path__ + "img/antes_despues_301.6bd2709b.png";